import {Error, ValidationResult, Validator} from '@/type/validation/result';

import {必須入力, 日付書式} from '@/type/validation/validator';
import {移動入力型} from '@/type/movement/records/register/部署間移動入力';

export default class 部署間移動入力チェッカー {
  単項目チェック結果: Error[] = [];
  相関チェック結果: Error[] = [];

  constructor(target: 移動入力型[], バラ管理である: boolean) {
    if (バラ管理である) {
      const 単項目チェック = new ValidationResult(バラ管理単項目チェックValidators);
      単項目チェック.validateList(target);
      this.単項目チェック結果 = 単項目チェック.getErrors;
      this.相関チェック結果 = 相関チェック(target);
    } else {
      const 単項目チェック = new ValidationResult(単項目チェックvalidators);
      単項目チェック.validateList(target);
      this.単項目チェック結果 = 単項目チェック.getErrors;
    }
  }

  hasError(name: string, index: number = 0): boolean {
    return this.単項目チェック結果.some((error) => (error.name === name && error.index === index));
  }

  hasErrors(): boolean {
    return this.単項目チェック結果.length > 0 || this.相関チェック結果.length > 0;
  }

  errorMessages(): string[] {
    const errorMEssages = this.単項目チェック結果.concat(this.相関チェック結果)
      .sort((a, b) => a.index - b.index)
      .map((value) => `${value.message}`);
    return Array.from(new Set(errorMEssages));
  }
}

const 箱数Validator = {
  name: '箱数',
  constraints: [
    {method: 必須入力, message: '移動数は入力が必須です'},
    {method: ゼロより大, message: '移動数は0より大きな値にして下さい'},
  ],
};
const 移動年月日Validator = {
  name: '移動年月日',
  constraints: [
    {method: 必須入力, message: '移動年月日は入力が必須です'},
    {method: 日付書式, message: '移動年月日の書式を正しく入力してください'},
  ],
};
const 単項目チェックvalidators: Validator[] = [
  箱数Validator,
  移動年月日Validator,
];

const バラ管理単項目チェックValidators: Validator[] = [
  移動年月日Validator,
];

function ゼロより大(value: number): boolean {
  return value > 0;
}

function 移動する箱数もしくはバラ数のいずれも未入力である(value: 移動入力型) {
  return value.箱数 === 0 && value.バラ数 === 0;
}

function 在庫場所部署と移動先部署が同じである(value: 移動入力型) {
  return value.在庫部署コード === value.移動先部署コード;
}

function 相関チェック(target: 移動入力型[]): Error[] {
  const errors: Error[] = [];
  target.forEach((value, index): void => {
    if (移動する箱数もしくはバラ数のいずれも未入力である(value)) {
      errors.push({index, message: '移動数(箱)または移動数(バラ)は0より大きな値にして下さい', constraint: '', name: '移動数エラー'});
    }
    if (在庫場所部署と移動先部署が同じである(value)) {
      errors.push({index, message: '在庫場所部署と移動先部署は異なる部署を選択してください', constraint: '', name: '移動先部署エラー'});
    }
  });
  return errors;
}
